import axios from 'axios'

import { AuthController } from '@App/api'
import { routes } from '@Config/config'

import { BrowserLocalstorage } from '../store'

const instance = axios.create()

instance.interceptors.request.use((config) => {
    if (config.headers) {
        const accessToken = BrowserLocalstorage.getToken()
        const env = BrowserLocalstorage.getEnvironment()
        if (env) {
            config.headers.Environment = env
        }
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }
    }
    return config
})

instance.interceptors.response.use(
    (config) => config,
    async (error) => {
        const originalRequest = error.config
        if (error.response) {
            if (error.config.url.includes('/token-refresh')) {
                window.location.replace(`${window.location.origin}${routes.AUTH}`)
                return
            }
            if ((error.response.status === 401 || error.response.status === 403) && !error.config?._isRetry) {
                originalRequest._isRetry = true
                const accessToken = BrowserLocalstorage.getToken()
                if (accessToken) {
                    const client = new AuthController()
                    try {
                        const { data } = await client.onRefreshAccessToken(accessToken)
                        BrowserLocalstorage.setToken(data.accessToken)
                        return instance.request(originalRequest) // eslint-disable-line
                    } catch (e) {
                        BrowserLocalstorage.removeToken()
                        window.location.replace(`${window.location.origin}${routes.AUTH}`)
                    }
                }
            }
            return Promise.reject(error) as any
        }
    }
)

export default instance
